import { ENV } from '@/config/env/env.read';

export const socketEndpoint = (): { origin: string; path: string } => {
    try {
        const url = new URL(ENV.apiUrl);
        const prefix = url.pathname.replace(/\/+$/, '');
        return { origin: url.origin, path: `${prefix}/realtime` };
    } catch {
        return { origin: '', path: '/realtime' };
    }
};

export default socketEndpoint;
